import { ProjectState } from './types'

export const state: ProjectState = {
  projects: [],
}
